const initTrigger = (rewardsTrigger) => {
  const toki = document.querySelector("#toki-shopify-integration-embed-wallet-v2-root");
  if (!toki || !toki.shadowRoot) return;

  const tokiWalletTrigger = toki.shadowRoot.querySelector(".toki-wallet--switcher-wrapper");
  if (!tokiWalletTrigger) return;

  tokiWalletTrigger.click();
}

document.addEventListener('DOMContentLoaded', () => {
  const rewardsTrigger = document.querySelector('.js-rewards-trigger');
  if (!rewardsTrigger) return;

  rewardsTrigger.addEventListener('click', () => {
    initTrigger(rewardsTrigger)
  });
});
